module.exports = __webpack_public_path__ + "assets/img/af08-sl.svg";